export const Config = {
  FullName: 'Michał Paczka',
  NIP: '631-154-68-04',
  REGON: '241042730',
  KRS: 'I/645/2008',
  CompanyAddress: 'Gliwice, ul. Zwycięstwa 14/56 (II piętro)',
  BankAccount: 'ING Bank Śląski 83 1050 1285 1000 0002 0215 1718',
  PhoneNumber: '+48 602 610 023',
  Email: 'mpaczka@gmail.com',
  Price: { Individual: 150, Family: 200 },
  CertificatNumber: 'SP/0092/2006',
  AssociateFullName: 'Teresą Trautman',
};
